import React from 'react';
import { COLORS, FONTS, primaryButtonStyle } from '../signup/signupStyles';

export const ValuePreview = ({ condition, question, answers, onContribute }) => (
  <div style={{
    minHeight: '80vh', backgroundColor: COLORS.bg, padding: '80px 20px 40px',
    fontFamily: FONTS.system
  }}>
    <style>{`
      @keyframes fadeUp {
        from { opacity: 0; transform: translateY(12px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes stagger1 { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
      @keyframes stagger2 { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
      @keyframes stagger3 { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
    `}</style>

    <div style={{ maxWidth: '600px', margin: '0 auto' }}>
      {/* Question */}
      <div style={{
        textAlign: 'center', marginBottom: '32px',
        animation: 'fadeUp 0.5s ease-out'
      }}>
        <div style={{
          fontSize: '12px', fontWeight: '600', textTransform: 'uppercase',
          letterSpacing: '0.8px', color: COLORS.salmon, marginBottom: '12px'
        }}>
          {condition} Community
        </div>
        <h1 style={{
          fontFamily: FONTS.serif, fontSize: 'clamp(22px, 4vw, 28px)',
          fontWeight: '700', color: COLORS.text, lineHeight: 1.4,
          margin: 0
        }}>
          {question.question}
        </h1>
      </div>

      {/* Community answers */}
      {answers.slice(0, 3).map((item, i) => (
        <div key={item.id} style={{
          backgroundColor: '#fff', borderRadius: '12px', padding: '24px',
          marginBottom: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
          animation: `stagger${i + 1} 0.4s ease-out ${0.15 * (i + 1)}s both`
        }}>
          <p style={{
            fontSize: '15px', color: COLORS.text, lineHeight: 1.6,
            margin: '0 0 12px'
          }}>
            "{item.text}"
          </p>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}>
            <div style={{ fontSize: '13px', color: COLORS.muted }}>
              {item.author} · diagnosed {item.diagnosisTime}
            </div>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '4px',
              fontSize: '13px', color: COLORS.muted
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill={COLORS.salmon}
                stroke="none">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
              {item.votes}
            </div>
          </div>
        </div>
      ))}

      {/* Plain-text count of additional answers */}
      {answers.length > 3 && (
        <div style={{
          textAlign: 'center', padding: '16px', marginBottom: '24px',
          fontSize: '14px', color: COLORS.muted,
          animation: 'stagger3 0.4s ease-out 0.6s both'
        }}>
          {answers.length - 3} more {answers.length - 3 === 1 ? 'patient' : 'patients'} answered this question
        </div>
      )}

      {/* CTA */}
      <div style={{
        textAlign: 'center', padding: '32px',
        backgroundColor: '#fff', borderRadius: '12px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
        animation: 'fadeUp 0.5s ease-out 0.5s both'
      }}>
        <h2 style={{
          fontFamily: FONTS.serif, fontSize: '20px', fontWeight: '700',
          color: COLORS.text, margin: '0 0 8px'
        }}>
          Have your own answer?
        </h2>
        <p style={{
          fontSize: '14px', color: COLORS.muted, margin: '0 0 20px',
          lineHeight: 1.5
        }}>
          Share your experience and see how others respond.
        </p>
        <button onClick={onContribute}
          style={{ ...primaryButtonStyle, padding: '16px 32px' }}
          onMouseEnter={(e) => { e.target.style.backgroundColor = '#3a3a39'; }}
          onMouseLeave={(e) => { e.target.style.backgroundColor = COLORS.text; }}
        >
          Add Your Voice
        </button>
      </div>
    </div>
  </div>
);
